import { getSearchUrl } from '#helpers/searchUrl';
import { generateUrl } from '#modules/expertDirectory/helpers';

export const createSearchUrl = (locale: string, query?: string, location?: string) => {
  const url = `/${generateUrl(query ?? '')}/${location ?? ''}`;

  return `/${locale}/${getSearchUrl(locale)}${url}`;
};
